var map = {
	"./cv/messages.js": 14,
	"./eo/messages.js": 15,
	"./ru/messages.js": 16
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7;


//////////////////
// WEBPACK FOOTER
// ./src/lang \.js$
// module id = 7
// module chunks = 0